import { Dispatch } from "redux";
import { services } from "../services";
import { userIdStorage, extractUserIdFromAuth } from "./user.action";

interface ActionData<T> {
  type: string;
  data: T;
}

// Define interfaces for various data types
interface NFTData {
  id?: string;
  [key: string]: any; // Additional properties based on your NFT structure
}

function setData<T>(data: T, type: string): ActionData<T> {
  return {
    type: type,
    data: data,
  };
}

function addNFT(data: NFTData) {
  return (dispatch: Dispatch) => {
    const url = "nft/addNft";
    const params = JSON.stringify(data);
    const response = services.post(url, params);
    response.then((promise: any) => {
      if (promise.status === 200) {
        dispatch(setData(promise.data.data, "ADD_NFT"));
      } else {
        // console.log('erroer');
      }
    });
  };
}

function authLogin(message: string, signature: string) {
  return (dispatch: Dispatch) => {
    const url = "user/login";
    const params = JSON.stringify({
      nonce: message, // Using message instead of nonce
      signature: signature,
    });

    const response = services.post(url, params);
    response.then(async (promise: any) => {
      if (promise?.status === 200) {
        localStorage.setItem("RwaAuthToken", promise?.data.data.token);
        if (promise?.data.data.token) {
          // Store userId in localStorage for easy access
          if (promise?.data.data.details?.id) {
            userIdStorage.setUserId(promise.data.data.details.id);
          }

          // Check if user is using thirdweb
          const usingThirdweb = localStorage.getItem("usingThirdweb");
          const existingUserAddress = localStorage.getItem("userAddress");

          const newresp = await services.getWeb3();

          // For thirdweb users, preserve the existing userAddress if web3 doesn't return accounts
          if (
            usingThirdweb &&
            existingUserAddress &&
            (!newresp.accounts || newresp.accounts.length === 0)
          ) {
            newresp.accounts = [existingUserAddress];
            localStorage.setItem("userAddress", existingUserAddress);
          } else if (newresp.accounts && newresp.accounts.length > 0) {
            localStorage.setItem("userAddress", newresp.accounts[0]);
          }

          localStorage.setItem("isLoggedIn", "true");
          newresp.isLoggedIn = true;
          dispatch(setData(newresp, "FETCH_WEB3_DATA"));
        }
        dispatch(
          setData(
            { data: promise.data.data.details, status: true },
            "AUTH_LOGIN"
          )
        );
      } else {
        localStorage.setItem("RwaAuthToken", "");
      }
    });
  };
}
function web2Login(hexMessage: string) {
  return (dispatch: Dispatch) => {
    const url = "user/web2-login";
    const params = JSON.stringify({
      walletAddress: hexMessage,
    });

    const response = services.post(url, params);
    response.then(async (promise: any) => {
      if (promise.status === 200) {
        localStorage.setItem("RwaAuthToken", promise.data.data.token);
        if (promise.data.data.token) {
          // Store userId in localStorage for easy access
          if (promise?.data.data.details?.id) {
            userIdStorage.setUserId(promise.data.data.details.id);
          }

          // Check if user is using thirdweb
          const usingThirdweb = localStorage.getItem("usingThirdweb");
          const existingUserAddress = localStorage.getItem("userAddress");

          const newresp = await services.getWeb3();

          // For thirdweb users, preserve the existing userAddress if web3 doesn't return accounts
          if (
            usingThirdweb &&
            existingUserAddress &&
            (!newresp.accounts || newresp.accounts.length === 0)
          ) {
            newresp.accounts = [existingUserAddress];
            localStorage.setItem("userAddress", existingUserAddress);
          } else if (newresp.accounts && newresp.accounts.length > 0) {
            localStorage.setItem("userAddress", newresp.accounts[0]);
          }

          localStorage.setItem("isLoggedIn", "true");
          newresp.isLoggedIn = true;
          dispatch(setData(newresp, "FETCH_WEB3_DATA"));
        }
        dispatch(
          setData(
            { data: promise.data.data.details, status: true },
            "AUTH_LOGIN"
          )
        );
      } else {
        localStorage.setItem("RwaAuthToken", "");
      }
    });
  };
}

function generateNonce(address: string) {
  return async (dispatch: Dispatch) => {
    const url = `user/genrateNonce/${address}`;
    const response = services.get(url, true);
    response.then((promise: any) => {
      if (promise.status === 200) {
        dispatch(setData(promise.data.data.nonce, "GENERATE_NONCE"));
      } else {
        // console.log("erroer");
      }
    });
  };
}

function getCategoryList() {
  return async (dispatch: Dispatch) => {
    const url = `category/list`;
    const response = services.get(url, false);
    response.then((promise: any) => {
      if (promise.status === 200) {
        dispatch(setData(promise.data.data, "CATEGORY_LIST"));
      } else {
        // console.log("erroer");
      }
    });
  };
}

function getCollectionList() {
  return async (dispatch: Dispatch) => {
    const url = `nft/listCollection`;
    const response = services.get(url, true);
    response.then((promise: any) => {
      if (promise.status === 200) {
        dispatch(setData(promise.data.data, "COLLECTION_LIST"));
      } else {
        // console.log("erroer");
      }
    });
  };
}

function getUserDetails() {
  return (dispatch: Dispatch) => {
    const response = services.get("user/userDetails", true);

    response.then(async (promise: any) => {
      if (promise.status === 200) {
        if (promise.data.data) {
          const userId = extractUserIdFromAuth(promise.data);
          if (userId) {
            userIdStorage.setUserId(userId);
          }

          // Check if user is using thirdweb
          const usingThirdweb = localStorage.getItem("usingThirdweb");
          const existingUserAddress = localStorage.getItem("userAddress");

          const newresp = await services.getWeb3();

          // Add null/undefined checks for newresp
          if (newresp && newresp.accounts && newresp.accounts.length > 0) {
            localStorage.setItem("userAddress", newresp.accounts[0]);
            newresp.isLoggedIn = true;
            dispatch(setData(newresp, "FETCH_WEB3_DATA"));
          } else if (usingThirdweb && existingUserAddress) {
            // For thirdweb users, preserve the existing userAddress if web3 doesn't return accounts
            newresp.accounts = [existingUserAddress];
            localStorage.setItem("userAddress", existingUserAddress);
            newresp.isLoggedIn = true;
            dispatch(setData(newresp, "FETCH_WEB3_DATA"));
          }
        }
        dispatch(setData(promise.data, "AUTH_LOGIN"));
      } else {
        localStorage.setItem("RwaAuthToken", "");
        if (promise.response && promise.response.status === 401) {
          dispatch(setData(promise.response, "AUTH_LOGIN_ERROR"));
        }
      }
    });
  };
}

function getUserProfile(id: string) {
  return async (dispatch: Dispatch) => {
    const response = services.get(`user/getSingleUser/${id}`, true);
    response.then((promise: any) => {
      if (promise.status === 200) {
        dispatch(setData(promise.data.data, "FETCHED_USER_PROFILE"));
      } else {
        // console.log("error");
      }
    });
  };
}

function updateNFT(data: NFTData & { id: string }) {
  return async (dispatch: Dispatch) => {
    const url = `nft/updateNft/${data.id}`;
    await services.put(url, data).then((response: any) => {
      if (response.status === 200) {
        dispatch(setData(response.data, "UPDATE_NFT"));
      }
      if (response.response && response.response.status === 403) {
        dispatch(setData(response.response.data, "UPDATE_NFT"));
      }
      if (response.response && response.response.status === 400) {
        dispatch(setData(response.response.data, "UPDATE_NFT"));
      }
    });
  };
}

export const defiActions = {
  addNFT,
  authLogin,
  generateNonce,
  getCategoryList,
  getCollectionList,
  getUserDetails,
  getUserProfile,
  updateNFT,
  web2Login,
};
